import { Side, BorderOption, BorderStyle } from '../../layout/constants'

export const Sides = [Side.TOP, Side.RIGHT, Side.BOTTOM, Side.LEFT]
const valueMapper = (data) => (data != null && data.value != null ? data.value : data)

export default class Borders {
  constructor(style, width, height) {
    this[BorderOption.STYLE] = [
      style.borderTopStyle,
      style.borderRightStyle,
      style.borderBottomStyle,
      style.borderLeftStyle,
    ]
    this[BorderOption.WIDTH] = [
      style.borderTopWidth,
      style.borderRightWidth,
      style.borderBottomWidth,
      style.borderLeftWidth,
    ].map(valueMapper)
    this[BorderOption.COLOR] = [
      style.borderTopColor,
      style.borderRightColor,
      style.borderBottomColor,
      style.borderLeftColor,
    ]
    this[BorderOption.RADIUS] = [
      style.borderTopLeftRadius,
      style.borderTopRightRadius,
      style.borderBottomRightRadius,
      style.borderBottomLeftRadius,
    ].map(valueMapper)
    const maxRadius = Math.min(width, height) / 2
    for (let i = 0; i < this.Radius.length; i++) {
      if (this.Radius[i] > maxRadius) {
        this.Radius[i] = maxRadius
      }
    }
    this.width = width
    this.height = height
  }

  isOptionEqual(o, v) {
    v = typeof v === 'undefined' ? this[o][0] : v
    return this[o][0] === v && this[o][1] === v && this[o][2] === v && this[o][3] === v
    // return this[o].every(item => item === v)
  }

  isSameAppearance() {
    return (
      this.isOptionEqual(BorderOption.STYLE) &&
      this.isOptionEqual(BorderOption.WIDTH) &&
      this.isOptionEqual(BorderOption.COLOR)
    )
  }

  isSameRadius() {
    return this.isOptionEqual(BorderOption.RADIUS)
  }

  getWidth(index = 0) {
    const style = this[BorderOption.STYLE][index]
    if (style === BorderStyle.NONE) {
      return 0
    }
    return this[BorderOption.WIDTH][index] || 0
  }

  getStyle(index = 0) {
    return this[BorderOption.STYLE][index]
  }

  getPoints(side) {
    const index = Sides.indexOf(side)
    const width = this.getWidth(index)

    if (!width) {
      return null
    }

    const leftIndex = index > 1 ? getNextIndex(index) : getPreviousIndex(index)
    const rightIndex = index > 1 ? getPreviousIndex(index) : getNextIndex(index)

    const prevWidth = this.getWidth(leftIndex)
    const nextWidth = this.getWidth(rightIndex)

    const isHorizontal = index % 2 === 0
    const flipMultiplier = index === 1 || index === 2 ? -1 : 1
    const length = isHorizontal ? this.width : this.height

    const p1 = [0, 0]
    const p2 = [length, 0]
    const p3 = [length - nextWidth, width * flipMultiplier]
    const p4 = [prevWidth, width * flipMultiplier]

    if (side === Side.LEFT) {
      return [...p1.reverse(), ...p4.reverse(), ...p3.reverse(), ...p2.reverse()]
    }

    if (side === Side.RIGHT) {
      p1.reverse()
      p2.reverse()
      p3.reverse()
      p4.reverse()
      const res = [...p4, ...p1, ...p2, ...p3]
      const xOffset = this.width
      return addOffset(res, xOffset, 0)
    }

    if (side === Side.BOTTOM) {
      const yOffset = this.height
      const res = [...p1, ...p4, ...p3, ...p2]
      return addOffset(res, 0, yOffset)
    }

    return [...p1, ...p2, ...p3, ...p4]
  }
}

function getPreviousIndex(index) {
  return index === 0 ? 3 : index - 1
}

function getNextIndex(index) {
  return index === 3 ? 0 : index + 1
}

function addOffset(items, xOffset = 0, yOffset = 0) {
  for (let i = 0; i < items.length; i++) {
    const offset = i % 2 === 0 ? xOffset : yOffset
    items[i] += offset
  }
  return items
}
